<div class="row">
  <div class="legal-notice">
    <h1>{{ legalNoticeMessages.titre | translate }}</h1>

    <p>{{ legalNoticeMessages.serviceTexteDebut | translate }}
      <a [routerLink]="[legalNoticeMessages.serviceUrl | translate]"
         [attr.aria-label]="legalNoticeMessages.serviceTexteLien | translate">{{ legalNoticeMessages.serviceTexteLien | translate }}</a>{{ legalNoticeMessages.serviceTexteFin | translate }}</p>

    <h2>{{ legalNoticeMessages.adresseTitre | translate }}</h2>
    <p>{{ legalNoticeMessages.adresseNom | translate }}</p>
    <p>{{ legalNoticeMessages.adresseLigne1 | translate }}</p>
    <p>{{ legalNoticeMessages.adresseLigne2 | translate }}</p>
    <p>{{ legalNoticeMessages.adresseLigne3 | translate }}</p>

    <h2>{{ legalNoticeMessages.realisationEditorialeTitre | translate }}</h2>
    <p>{{ legalNoticeMessages.realisationEditorialeTexte | translate }}</p>

    <h2>{{ legalNoticeMessages.directeurPublicationTitre | translate }}</h2>
    <p>{{ legalNoticeMessages.directeurPublicationNom | translate }}</p>

    <h2>{{ legalNoticeMessages.realisationTitre | translate }}</h2>
    <p>{{ legalNoticeMessages.realisationNom | translate }}</p>
    <p>{{ legalNoticeMessages.realisationAdresse | translate }}</p>
    <p>{{ legalNoticeMessages.realisationVille | translate }}</p>

    <h2>{{ legalNoticeMessages.exploitationTitre | translate }}</h2>
    <p>{{ legalNoticeMessages.exploitationNom | translate }}</p>
    <p>{{ legalNoticeMessages.exploitationLigne1 | translate }}</p>
    <p>{{ legalNoticeMessages.exploitationLigne2 | translate }}</p>
    <p>{{ legalNoticeMessages.exploitationLigne3 | translate }}</p>

    <h2>{{ legalNoticeMessages.hebergementTitre | translate }}</h2>
    <p>{{ legalNoticeMessages.hebergementNom | translate }}</p>
    <p>{{ legalNoticeMessages.hebergementAdresse | translate }}</p>
    <p>{{ legalNoticeMessages.hebergementCodePostal | translate }}</p>

    <h2>{{ legalNoticeMessages.droitsReproductionTitre | translate }}</h2>
    <p>{{ legalNoticeMessages.droitsReproductionCopie | translate }}</p>
    <p>{{ legalNoticeMessages.droitsReproductionLiens | translate }}</p>
  </div>
</div>
